var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuVat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Material/Icons/\uBD80\uAC00\uC138\uC2E0\uACE0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "1.03993854e-15 0 9.4237207 0 9.4237207 2.08987999 1.03993854e-15 2.08987999"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "1.03993854e-15 4.15975417e-15 4.71156763 4.15975417e-15 4.71156763 2.08970436 1.03993854e-15 2.08970436"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 22 23.5789138 22 23.5789138 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material/Icons/\\uBD80\\uAC00\\uC138\\uC2E0\\uACE0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-63",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4984007,20.6851167 L10.4984007,15.9811597 L13.1281673,15.9811597 L13.1281673,20.6851167 C13.1281673,21.411054 12.5392214,22 11.813284,22 C11.0873467,22 10.4984007,21.411054 10.4984007,20.6851167 Z",
    id: "Fill-1",
    fill: "#D5D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.813284,2.2 C11.6692674,2.2 11.5264217,2.2070252 11.3859177,2.22166103 C11.5264217,2.2070252 11.6692674,2.2 11.813284,2.2 Z",
    id: "Fill-3",
    fill: "#44C4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82199101,2.70423375 C10.1773491,2.51104074 10.5637351,2.368195 10.9711967,2.28506347 C10.5637351,2.368195 10.1773491,2.51104074 9.82199101,2.70423375",
    id: "Fill-5",
    fill: "#44C4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34909923,4.04189042 C8.29348306,4.12443652 8.24372123,4.21108066 8.19395939,4.29772479 L8.19395939,4.29772479 C8.24372123,4.21108066 8.29348306,4.12443652 8.34909923,4.04189042",
    id: "Fill-7",
    fill: "#44C4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.813284,3.30389313 C10.9210836,3.30389313 10.1190399,3.68852285 9.55702387,4.29737353 L14.0695442,4.29737353 C13.5075281,3.68852285 12.7054844,3.30389313 11.813284,3.30389313",
    id: "Fill-9",
    fill: "#F95F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19384231,8.45793129 C8.24360414,8.54457543 8.29336598,8.63121956 8.34898214,8.71376567 C8.29336598,8.63121956 8.24360414,8.54457543 8.19384231,8.45793129",
    id: "Fill-11",
    fill: "#44C4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.813284,9.45152878 C12.7054844,9.45152878 13.5075281,9.06689907 14.0695442,8.45804838 L9.55702387,8.45804838 C10.1190399,9.06689907 10.9210836,9.45152878 11.813284,9.45152878",
    id: "Fill-13",
    fill: "#F95F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9713723,10.4705341 C10.5633253,10.3868171 10.1769392,10.2439714 9.82216664,10.0513638 C10.1769392,10.2439714 10.5633253,10.3868171 10.9713723,10.4705341",
    id: "Fill-15",
    fill: "#44C4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.578621,2.08987999 L17.9350435,2.08987999 C18.4028048,2.75493228 18.7628463,3.49843264 18.9946779,4.29754916 L21.3709519,4.29754916 L21.3709519,8.45763857 L18.9946779,8.45763857 C18.7628463,9.25734054 18.4022193,10.0002555 17.9350435,10.6658932 L23.578621,10.6658932 L23.578621,2.08987999 Z",
    id: "Fill-17",
    fill: "#F95F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.813284,10.5553634 L11.813284,10.5553634 C11.6692674,10.5553634 11.5264217,10.5483382 11.3859177,10.5337023 C11.5264217,10.5483382 11.6692674,10.5553634 11.813284,10.5553634",
    id: "Fill-19",
    fill: "#44C4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.82199101,10.0511882 C9.46663296,9.85799516 9.14288832,9.61504032 8.85953857,9.33169057 C9.14288832,9.61504032 9.46663296,9.85799516 9.82199101,10.0511882",
    id: "Fill-21",
    fill: "#44C4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.20772772,8.45793129 L2.20772772,4.29784188 L4.6314218,4.29784188 C4.86383885,3.49872535 5.22388036,2.75522499 5.69164161,2.0901727 L5.85433354e-05,2.0901727 L5.85433354e-05,10.6656005 L5.69164161,10.6656005 C5.22446579,10.0005482 4.86383885,9.25704782 4.63200724,8.45793129 L2.20772772,8.45793129 Z",
    id: "Fill-23",
    fill: "#F95F53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85924586,3.4236728 C9.1425956,3.14032305 9.46692568,2.89736821 9.82169829,2.7041752 C9.46692568,2.89736821 9.1425956,3.14032305 8.85924586,3.4236728",
    id: "Fill-25",
    fill: "#44C4A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72051944,7.2196812 C7.66490327,6.9474547 7.6356316,6.66586125 7.6356316,6.37782804 C7.6356316,6.0892094 7.66490327,5.80761596 7.72051944,5.53597488 C7.77613561,5.26374837 7.85809628,5.00147423 7.96405971,4.75149419 C8.03021368,4.59459805 8.10924719,4.44414167 8.19354959,4.29778334 L5.78917481,4.29778334 C5.56378296,4.95054153 5.43557306,5.64837808 5.43557306,6.37782804 C5.43557306,7.107278 5.56378296,7.80511456 5.78917481,8.45787275 L8.19413502,8.45787275 C8.10924719,8.31151441 8.03021368,8.16105804 7.96405971,8.0041619 C7.85809628,7.75418186 7.77613561,7.49190771 7.72051944,7.2196812",
    id: "Fill-27",
    fill: "#FCD462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8374518,4.29760771 L15.433077,4.29760771 C15.7860933,4.91055643 15.990995,5.61951622 15.990995,6.37765241 C15.990995,7.13578861 15.7860933,7.8447484 15.433077,8.45769712 L17.8374518,8.45769712 C18.0628436,7.80493893 18.1910535,7.10710237 18.1910535,6.37765241 C18.1910535,5.64820245 18.0628436,4.9503659 17.8374518,4.29760771",
    id: "Fill-29",
    fill: "#FCD462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.813284,12.7557146 C12.2535299,12.7557146 12.683238,12.7112217 13.0988957,12.6263339 C14.4459778,12.3505947 15.6332366,11.6451476 16.5248516,10.6657176 L7.10171638,10.6657176 C8.26848506,11.9466457 9.94399532,12.7557146 11.813284,12.7557146",
    id: "Fill-31",
    fill: "#FCD462"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(7.101541, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.03993854e-15,2.08987999 L9.4237207,2.08987999 C8.53152026,1.11044999 7.34426142,0.405002794 5.99717928,0.129263685 C5.58210703,0.0443758482 5.15181351,-0.000117086671 4.71156763,-0.000117086671 C2.84227893,-0.000117086671 1.16676867,0.808951808 1.03993854e-15,2.08987999",
    id: "Fill-33",
    fill: "#FCD462",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.78923335,4.29760771 L8.19360813,4.29760771 C8.24336997,4.21096357 8.2931318,4.12431943 8.3493334,4.04177333 C8.49920434,3.81989409 8.67015088,3.61265068 8.85924586,3.42355571 C9.1425956,3.14020597 9.46692568,2.89725112 9.82169829,2.70405812 C10.1770563,2.51145054 10.5634423,2.36860481 10.9714894,2.28488784 C11.1073099,2.25678704 11.2454722,2.23571143 11.3859762,2.22166103 C11.5264802,2.2070252 11.669326,2.2 11.8133426,2.2 L11.8133426,2.2 C12.2459778,2.2 12.6633918,2.26556854 13.0556321,2.38792411 C13.1861838,2.42831901 13.3143937,2.47573911 13.4396764,2.52842811 C13.9390511,2.73976955 14.3892493,3.04536576 14.7674393,3.42355571 C15.0267862,3.68290269 15.2486655,3.9779611 15.433077,4.29760771 L17.8374518,4.29760771 C17.5517603,3.47097581 17.101562,2.72337742 16.5249102,2.08993853 L7.10177493,2.08993853 C6.52512307,2.72337742 6.07492483,3.47097581 5.78923335,4.29760771",
    id: "Fill-36",
    fill: "#FCD462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7673807,9.33174912 C14.3891908,9.70993906 13.9389925,10.0155353 13.4396179,10.2268767 C13.3143351,10.2801511 13.1861252,10.3269858 13.0555736,10.3673807 C12.6633332,10.4897363 12.2459193,10.5553048 11.813284,10.5553048 L11.813284,10.5553048 C11.6692674,10.5553048 11.5264217,10.5482796 11.3859177,10.5336438 C11.2454137,10.5195934 11.1072514,10.4985178 10.9714309,10.470417 C10.5633838,10.3872855 10.1769978,10.2438543 9.82222518,10.0512467 C9.46686713,9.8580537 9.14253706,9.61509886 8.85918731,9.33174912 C8.67009234,9.14265414 8.4991458,8.93599617 8.34927486,8.71353149 C8.29365869,8.63098539 8.24389686,8.54434125 8.19413502,8.45769712 L5.78917481,8.45769712 C6.07486628,9.28491445 6.52506453,10.0325128 7.10171638,10.6653663 L16.5248516,10.6653663 C17.1015035,10.0325128 17.5517017,9.28491445 17.8373932,8.45769712 L15.4330184,8.45769712 C15.2486069,8.77734373 15.0267277,9.07240214 14.7673807,9.33174912",
    id: "Fill-38",
    fill: "#FCD462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0986615,12.6260997 C12.6835892,12.7109875 12.2532957,12.7554805 11.8130498,12.7554805 L11.8130498,12.7554805 C9.94434658,12.7554805 8.26825088,11.9464116 7.10148221,10.6654834 L5.6917587,10.6654834 C7.04645148,12.5939008 9.28280689,13.8596078 11.8130498,13.8596078 C14.3432928,13.8596078 16.5802336,12.5939008 17.9349264,10.6654834 L16.5252029,10.6654834 C15.6330025,11.6449134 14.4457436,12.3503606 13.0986615,12.6260997",
    id: "Fill-40",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-44",
    transform: "translate(7.101716, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71156763,-0.000292716677 L4.71156763,-0.000292716677 C2.84227893,-0.000292716677 1.16618324,0.808776178 1.03993854e-15,2.08970436 L1.03993854e-15,2.08970436 C1.16618324,0.808776178 2.84227893,-0.000292716677 4.71156763,-0.000292716677",
    id: "Fill-42",
    fill: "#FFFFFF",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.10165784,10.665659 L7.10165784,10.665659 C8.26842651,11.9465872 9.94393677,12.7556561 11.8132255,12.7556561 L11.8132255,12.7556561 C9.94393677,12.7556561 8.26842651,11.9465872 7.10165784,10.665659",
    id: "Fill-45",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43533889,6.37771096 C5.43533889,5.648261 5.56354879,4.95042444 5.78894063,4.29766625 L5.78894063,4.29766625 C5.56354879,4.95042444 5.43533889,5.648261 5.43533889,6.37771096 C5.43533889,7.10716091 5.56354879,7.80499747 5.78952607,8.45775566 L5.78952607,8.45775566 C5.56354879,7.80499747 5.43533889,7.10716091 5.43533889,6.37771096",
    id: "Fill-47",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7673807,9.33174912 C14.3891908,9.70993906 13.9389925,10.0155353 13.4396179,10.2268767 C13.9389925,10.0155353 14.3891908,9.70993906 14.7673807,9.33174912",
    id: "Fill-49",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4394422,2.52831102 C13.9394023,2.73965247 14.3896006,3.04583411 14.7672051,3.42343862 C14.3896006,3.04583411 13.9394023,2.73965247 13.4394422,2.52831102",
    id: "Fill-51",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.813284,2.2 L11.813284,2.2 C12.2459193,2.2 12.6633332,2.26556854 13.0555736,2.38792411 C12.6633332,2.26556854 12.2459193,2.2 11.813284,2.2",
    id: "Fill-53",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0555736,10.3674393 C12.6633332,10.4897948 12.2459193,10.5553634 11.813284,10.5553634 C12.2459193,10.5553634 12.6633332,10.4897948 13.0555736,10.3674393 Z",
    id: "Fill-55",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.78899918,4.29754916 C6.07469065,3.47091727 6.5248889,2.72331887 7.10154075,2.08987999 C6.5248889,2.72331887 6.07469065,3.47091727 5.78899918,4.29754916 Z",
    id: "Fill-57",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.10183347,10.6656005 C6.52518162,10.0321616 6.07498337,9.28456319 5.78929189,8.45793129 C6.07498337,9.28456319 6.52518162,10.0321616 7.10183347,10.6656005 Z",
    id: "Fill-59",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-62"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-61",
    fill: "#D5D6DB",
    mask: "url(#mask-6)",
    points: "10.7614359 15.3992389 12.8174778 15.3992389 12.8174778 13.343197 10.7614359 13.343197"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuVat);
export default __webpack_public_path__ + "static/media/menu_vat.33d2ec5b7791897a1b111aa1371106cb.svg";
export { ForwardRef as ReactComponent };